// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Box } from '@mui/material';
// utils
import Iconify from 'components/Iconify';
import { fShortenNumber } from 'utils/formatNumber';

// AnalyticsEachNumberData.propTypes = {
//   number: PropTypes.number,
//   title: PropTypes.string
// };

export default function AnalyticsEachNumberData(props) {
  const { title, number, sx, selectedFeature, val } = props;
  const selectResult = () => {
    if (val !== undefined && val !== '') selectedFeature(val);
  };
  return (
    <Card onClick={selectResult} sx={{ p: 1, width: '100%', backgroundColor: '#fff', borderRadius: '6px', ...sx }}>
      <Typography sx={{ fontSize: '16px', color: 'black', fontWeight: '700' }}>{title}</Typography>
      <Typography sx={{ fontSize: '20px', color: 'black', fontWeight: '700', mt: 1 }}>{number}</Typography>
    </Card>
  );
}
